import React from "react";
import "./CardStyles.css";

const BookmarkMentorsCard = ({
  name,
  title,
  thumbnail,
  mentorUrl,
  isMentorsPage,
  isSidebarOpen,
}) => {
  return (
    <div
      data-cy="bookmark-mentors-card"
      className={`card ${isMentorsPage ? "card-mentors-page" : ""} ${
        isSidebarOpen ? "" : "sidebar-closed-card"
      }`}
    >
      <p className="card-title">{name}</p>
      <div className="card-link">
        <img src={thumbnail} alt={title} className="card-thumbnail" />
      </div>
      <h3 className="card-subtitle">{title}</h3>
    </div>
  );
};

export default BookmarkMentorsCard;
